import { io } from 'socket.io-client';

const SOCKET_URL = new URL(process.env.REACT_APP_BASE_URL ?? 'http://localhost:5001/backend').origin;

export const socket = (token) => io(SOCKET_URL, {
  autoConnect: false,
  path: "/backend/webhook",
  secure: true,
  query: { token }
});